import { render, staticRenderFns } from "./exercisePrescriptionGuidance.vue?vue&type=template&id=fe5e47b8&"
import script from "./exercisePrescriptionGuidance.vue?vue&type=script&lang=js&"
export * from "./exercisePrescriptionGuidance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports